import { render } from "./BarcodesList.vue?vue&type=template&id=53efaad2"
import script from "./BarcodesList.vue?vue&type=script&lang=js"
export * from "./BarcodesList.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__